import * as React from "react";
import classnames from "classnames";
import { pushImageGalleryItemClickEvent } from "../../../../../../../Analytics/events/modules/Analytics/events/ImageGalleryEvents.js";
import { useImageSlider } from "../../../../../hooks/modules/ProductImageGallery/components/hooks/use-image-slider.js";
import { HorizontalImageSlider } from "../../../../../HorizontalImageSlider/modules/ProductImageGallery/components/HorizontalImageSlider/HorizontalImageSlider.js";
import { ZoomModal } from "../../../../../ZoomModal/modules/ProductImageGallery/components/ZoomModal/ZoomModal.js";
import { MobileProductImage } from "../../../../components/MobileProductImage/modules/ProductImageGallery/components/ProductImageGalleryMobile/components/MobileProductImage/MobileProductImage.js";
/* empty css                               */
import { useProductImageGallerySlots } from "../../../../../../slots/modules/ProductImageGallery/slots/context.js";
const ProductImageGalleryMobile = ({
  images,
  imageParams,
  sku,
  handleImageInteraction,
  zoomModalOpenIndex,
  hasTopSpacing = false
}) => {
  const { Slots } = useProductImageGallerySlots();
  const { setSlide, activeIndex, handleInView } = useImageSlider(images.length, {
    elementIdentifierString: "mobile__image-scroll-item"
  });
  const activeImage = images[activeIndex];
  const handleThumbnailClick = React.useCallback(
    (thumbnail) => {
      const activeImage2 = images.findIndex((image) => image.label === thumbnail.label);
      setSlide(activeImage2);
      sku && pushImageGalleryItemClickEvent(activeImage2, sku, thumbnail);
    },
    [images, setSlide, sku]
  );
  if (!Boolean(images.length)) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    "section",
    {
      className: classnames("product-image-gallery-mobile", {
        "product-image-gallery-mobile--has-top-spacing": hasTopSpacing
      })
    },
    Slots.TopLeft && /* @__PURE__ */ React.createElement(Slots.TopLeft, { className: "product-image-gallery-mobile__top-left" }),
    Slots.TopRight && /* @__PURE__ */ React.createElement(Slots.TopRight, { className: "product-image-gallery-mobile__top-right" }),
    /* @__PURE__ */ React.createElement("div", { className: "product-image-gallery-mobile__images" }, /* @__PURE__ */ React.createElement("div", { className: "product-image-gallery-mobile__wrapper" }, /* @__PURE__ */ React.createElement("div", { className: "product-image-gallery-mobile__image-scroller" }, images.map((image, index) => /* @__PURE__ */ React.createElement(
      MobileProductImage,
      {
        key: index,
        image,
        index,
        activeIndex,
        imageParams,
        handleImageInteraction,
        handleInView
      }
    )))), images.length > 1 && activeImage && /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "product-image-gallery-mobile__thumbnails",
        "data-t": "image-gallery-mobile__thumbnails"
      },
      /* @__PURE__ */ React.createElement(
        HorizontalImageSlider,
        {
          images,
          onClick: handleThumbnailClick,
          activeImage
        }
      )
    )),
    /* @__PURE__ */ React.createElement(
      ZoomModal,
      {
        isOpen: zoomModalOpenIndex !== null,
        openingIndex: activeIndex,
        onClose: () => handleImageInteraction(null),
        images
      }
    )
  );
};
export {
  ProductImageGalleryMobile,
  ProductImageGalleryMobile as default
};
//# sourceMappingURL=ProductImageGalleryMobile.js.map
